import { render, staticRenderFns } from "./CreateRoomScreen.vue?vue&type=template&id=4d73bed6&scoped=true"
import script from "./CreateRoomScreen.vue?vue&type=script&lang=js"
export * from "./CreateRoomScreen.vue?vue&type=script&lang=js"
import style0 from "./CreateRoomScreen.vue?vue&type=style&index=0&id=4d73bed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d73bed6",
  null
  
)

export default component.exports